import { Configuration } from '@azure/msal-browser'
import { SdkConfig } from 'sdk'

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MICROSOFT_TENANTS_ID!}`,
    redirectUri: SdkConfig.AppPath,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

export const msalloginRequestScopes = {
  scopes: ['User.Read'],
}
